import { makeAutoObservable } from "mobx";

class UserStore {
  _currentUser = {
    userID: "",
    firstName: "",
    lastName: "",
    role: "",
    session: "",
    sub: "",
    shardID: "",
    sections: [],
    riasec: [],
    profileChoices: null,
    userPaths: [],
    parentIDs: [],
  };
  preferredUserPath = null; // This is the path that the user has selected to use in the case they have more than one user record and it needs to be disambiguated.

  get currentUser() {
    // console.warn(
    //   "Warning: Don't get currentUser from userStore! This won't work right.",
    // );
    return this._currentUser;
  }

  set currentUser(value) {
    this._currentUser = value;
  }

  constructor() {
    makeAutoObservable(this);
    this.loadFromLocalStorage();
  }

  setUser(user) {
    this.currentUser = user;
    this.saveToLocalStorage();
  }

  removeUser() {
    this.currentUser = {
      userID: "",
      firstName: "",
      lastName: "",
      role: "",
      session: "",
      sub: "",
      shardID: "",
      profileChoices: null,
    };
    this.saveToLocalStorage();
  }

  setRole(role) {
    if (this.currentUser) {
      this.currentUser.role = role;
      this.saveToLocalStorage();
    }
  }

  setProfileChoices(choices) {
    if (this.currentUser) {
      this.currentUser = {
        ...this.currentUser,
        profileChoices: choices,
      };
      this.saveToLocalStorage();
    }
  }

  setPreferredUserPath(path) {
    this.preferredUserPath = path;
    this.saveToLocalStorage();
  }

  getPreferredUserPath() {
    return this.preferredUserPath;
  }

  getRole() {
    return this.currentUser ? this.currentUser.role : "";
  }

  saveToLocalStorage() {
    localStorage.setItem("currentUser", JSON.stringify(this.currentUser));
    localStorage.setItem(
      "preferredUserPath",
      JSON.stringify(this.preferredUserPath),
    );
  }

  loadFromLocalStorage() {
    const storedUser = localStorage.getItem("currentUser");
    if (storedUser) {
      this.currentUser = JSON.parse(storedUser);
    }
    const storedPreferredUserPath = localStorage.getItem("preferredUserPath");
    if (storedPreferredUserPath) {
      this.preferredUserPath = JSON.parse(storedPreferredUserPath);
    }
  }

  clearUser() {
    this.removeUser();
    this.preferredUserPath = null;
    localStorage.removeItem("currentUser");
    localStorage.removeItem("preferredUserPath");
  }
}

const userStore = new UserStore();
export default userStore;
